import EChart from 'echarts-for-react' 
import { useMemo } from 'react'

const StackBarChart = ({ series, yLabels }) => {

  const option = useMemo(() => ({
    grid: {
      left: 20,
      right: 25, 
      top: 30,
      bottom: 25,
      containLabel: true 
    },

    yAxis: {
      type: 'category',
      data: yLabels, 
      axisTick: { show: false }
    },
    
    xAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}'
      },
      name: '%', 
      nameLocation: 'middle',  
      nameGap: 25,
      nameTextStyle: {
        fontSize: 12,
        color: '#555'
      },
      min: 0,
      max: 100,
      interval: 20  
    },

    series: series.map(item => {
      return {
        ...item,
        barWidth: 14,
        type: "bar",
        stack: "total",
        itemStyle: {
          borderRadius: 0
        }
      }
    }),

    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      borderColor: '#ddd',
      borderWidth: 1,
      extraCssText: `
        box-shadow: 0 2px 8px rgba(0,0,0,0.12);
        border-radius: 8px;
        padding: 12px 14px;
      `,
      formatter: (params) => {
        if (!params || params.length === 0) return

        const title = params[0].name
        let total = 0

        params.forEach(p => {
          if (p.seriesType === 'bar') total += p.value || 0
        })

        let html = `
          <div style="font-weight:600;color:#222;margin-bottom:4px">${title}</div>
        `

        params.forEach(p => {
          if (p.seriesType !== 'bar') return

          const pct = ((p.value / total) * 100).toFixed(2)

          html += `
            <div style="
              display:flex;
              align-items:center;
              margin:2px 0;
              font-size:13px;
              color: #444;
            ">
              ${p.marker}
              <span style="margin-right:6px">${p.seriesName}</span>
              <span style="margin-left:auto;font-weight:600">${pct}%</span>
            </div>
          `
        })

        return html
      }
    },
    
    legend: {
      data: series.map(key => key.name),
      top: 0,
      itemWidth: 10,
      itemHeight: 10,
      itemGap: 18,
      textStyle: {
        fontSize: 12
      }
    },
  }), [series, yLabels]) 

  return (
    <div className="aspect-3/2 md:aspect-2/1">
      <EChart 
        opts={{ renderer: "svg"}}
        option={option} 
        notMerge
        style={{ height: '100%', width: '100%' }}
      />
    </div>
  )
}

export default StackBarChart